__turbopack_context__.v({
  "l": "Icon-module-scss-module__MfXWBq__l",
  "m": "Icon-module-scss-module__MfXWBq__m",
  "s": "Icon-module-scss-module__MfXWBq__s",
  "xl": "Icon-module-scss-module__MfXWBq__xl",
  "xs": "Icon-module-scss-module__MfXWBq__xs",
});
